import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {ResultProvider} from 'providers/ResultProvider'
import {Theme} from 'providers/Theme'
import {View} from './View'

export const Order = () => {
  return (
    <EnvironmentProvider>
      <Theme>
        <ResultProvider>
          <View />
        </ResultProvider>
      </Theme>
    </EnvironmentProvider>
  )
}
